import { useRef } from "react";
import { useAnimationFrame } from "@/utils";

export function useTeleprompterScroll(
  speed: number,
  isRecording: boolean,
  scrollToRef: React.RefObject<HTMLTextAreaElement | null>
) {
  const scrollAccumulator = useRef(0);

  useAnimationFrame(deltaTime => {
    const currentRef = scrollToRef?.current;
    if (isRecording && currentRef) {
      // Convert Pixels Per Second to Pixels Per Millisecond (scaled by 1.5x to match the 1.5x font size increase)
      const pixelsPerMs = (speed * 1.5) / 1000;

      // Calculate exactly how many fractional pixels we should have moved since the last frame
      const pixelsThisFrame = deltaTime * pixelsPerMs;

      scrollAccumulator.current += pixelsThisFrame;

      // Only fire a DOM update when we've built up at least 1 full pixel
      if (scrollAccumulator.current >= 1) {
        const pixelsToScroll = Math.floor(scrollAccumulator.current);
        currentRef.scrollTop += pixelsToScroll;
        scrollAccumulator.current -= pixelsToScroll; // Keep the remainder for the next frame!
      }
    }
  }, isRecording);

  return {
    scrollToRef,
    scrollAccumulator,
  };
}
